import { $lang } from '@msdk/common'
import { EMPTY_CELL_VALUE, FieldValue } from '@msdk/definitions'
import { Link, Typography } from '@msdk/ui'
import React from 'react'
import { useRecoilValue } from 'recoil'

import { Ellipsis } from './utils'

interface Props {
  clickable?: boolean
  onItemClick?: () => void
  value: FieldValue<unknown> | null
  ellipsis: boolean
}

export function StringCellRenderer({ clickable, onItemClick, value, ellipsis }: Props) {
  const lang = useRecoilValue($lang)
  const TypographyComponent = ellipsis ? Ellipsis : Typography

  if (value && clickable) {
    return (
      <TypographyComponent variant="body1">
        <Link underline="hover" onClick={onItemClick}>
          {value.toStringForView(lang)}
        </Link>
      </TypographyComponent>
    )
  }

  return (
    <TypographyComponent variant="body1">{value ? value.toStringForView(lang) : EMPTY_CELL_VALUE}</TypographyComponent>
  )
}
